import { ReactNode, lazy } from 'react'

const ContentEnrollmentPage = lazy(
  () => import('@/presentation/pages/content/content-enrollment/content-enrollment-page')
)

export const makeContentEnrollmentPage = (): ReactNode => {
  return <ContentEnrollmentPage />
}
